export const pains = [
  '« Il a annulé une fois, puis espacé les séances. Et un jour, plus de nouvelles. »',
  '« Séance 4, un mardi soir. Elle s’assoit et me dit : je ne sais pas si c’est pour moi. »',
  '« Les séances sont bonnes. Mais je ne sais plus très bien où on en est avec ce client. »',
  '« Je vends à la séance. Après, ils reviennent… ou pas. »',
  '« J’ai ma certification, mais seulement deux ou trois clients. »',
  '« Le papier ne fait pas tout. Face au client, je doute encore de ma légitimité. »',
  '« J’ai peur d’être mis(e) dans le même sac que les gourous. »',
  '« Je poste tous les jours pour exister, et les parcours s’arrêtent quand même à la quatrième séance. »',
]
